(() => {
  'use strict';

  function initSection(root) {
    const audioEl = root.querySelector('.media-audio__player');
    const muteBtn = root.querySelector('.media-audio__mute');
    const topTabs = Array.from(root.querySelectorAll('.media-audio__tab'));
    const inlineBtns = Array.from(root.querySelectorAll('.media-audio__inline-btn'));
    const highlight = root.querySelector('.media-audio__switcher .tab-highlight');
    const switcher = root.querySelector('.media-audio__switcher');

    if (!audioEl || !muteBtn || !switcher) return;

    const srcOn = audioEl.getAttribute('data-src-on') || '';
    const srcOff = audioEl.getAttribute('data-src-off') || '';
    let current = 'on'; // default selected

    // Update highlight position to active button
    function updateHighlight() {
      const active = switcher.querySelector('.media-audio__tab.is-active');
      if (!active || !highlight) return;
      const rect = active.getBoundingClientRect();
      const parentRect = switcher.getBoundingClientRect();
      const offset = Math.max(0, rect.left - parentRect.left);
      const width = rect.width;
      highlight.style.transform = `translateX(${offset}px)`;
      highlight.style.width = `${width}px`;
    }

    function setActive(mode, userInteraction = false) {
      current = mode; // 'on' | 'off'
      // Update top tabs
      topTabs.forEach(btn => {
        const isActive = btn.dataset.audio === mode;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      // Update inline buttons
      inlineBtns.forEach(btn => {
        const isActive = btn.dataset.audio === mode;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      updateHighlight();
      // Switch audio source
      const nextSrc = mode === 'on' ? srcOn : srcOff;
      if (nextSrc) {
        if (audioEl.src !== nextSrc) {
          audioEl.src = nextSrc;
          // ensure we can autoplay after src change if muted or user interacted
          audioEl.load();
        }
        // Unmute on any button click per requirement
        if (userInteraction) {
          audioEl.muted = false;
          muteBtn.setAttribute('aria-pressed', 'false');
        }
        playSafe(audioEl);
      }
    }

    // Intersection: play/pause when in view
    function playSafe(el) {
      const p = el.play?.();
      if (p && typeof p.then === 'function') {
        p.catch(() => {
          // Autoplay might be blocked; keep muted true if necessary
        });
      }
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Lazy set default src when first in view
          if (!audioEl.src) {
            const initial = current === 'on' ? srcOn : srcOff;
            if (initial) {
              audioEl.src = initial;
              audioEl.load();
            }
          }
          playSafe(audioEl);
        } else {
          audioEl.pause?.();
        }
      });
    }, { threshold: 0.35 });
    observer.observe(root);

    // Mute toggle
    muteBtn.addEventListener('click', () => {
      const nowMuted = !(audioEl.muted === false);
      audioEl.muted = !nowMuted ? false : true;
      muteBtn.setAttribute('aria-pressed', audioEl.muted ? 'true' : 'false');
      playSafe(audioEl);
    });

    // Top tabs events
    topTabs.forEach(btn => {
      btn.addEventListener('click', () => setActive(btn.dataset.audio, true));
    });
    // Inline buttons
    inlineBtns.forEach(btn => {
      btn.addEventListener('click', () => setActive(btn.dataset.audio, true));
    });

    // Initial states
    muteBtn.setAttribute('aria-pressed', 'true'); // muted initially
    // Defer highlight calculation to next frame for correct rects
    requestAnimationFrame(updateHighlight);
    window.addEventListener('resize', updateHighlight, { passive: true });
  }

  function initAll() {
    const sections = document.querySelectorAll('[id^="MediaAudio-"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

